import React, { SyntheticEvent } from "react";

import Href from "../../ui/Href";
import Props from "./props";
import useHistoryPush from "../../../../hooks/useHistoryPush";

const LinkHref: React.FC<Props> = ({ children, to }) => {
    const push = useHistoryPush(to);
    return (
        <Href
            href={to}
            shadow
            uppercase
            primary
            onClick={(e: SyntheticEvent) => {
                e.preventDefault();
                push();
            }}
        >
            {children}
        </Href>
    );
};

export default LinkHref;
